import styles from './styles.module.scss'
import { useEffect, useState } from 'react'
import { SingleTooltip } from '../SingleTooltip'
import clsx from 'clsx'

export const TooltipContainer = ({ active, targets, isVisible }) => {
  const [state, setState] = useState({
    clientX: 0,
    clientY: 0,
    width: 182,
    height: 40,
    offsetX: 10,
    offsetY: 10,
  })

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove, false)

    return () => window.removeEventListener('mousemove', handleMouseMove, false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleMouseMove = ({
    clientX: mouseClientX,
    clientY: mouseClientY,
  }) => {
    const { width } = state

    const tooltipHeight = 40

    const nextOffsetX = 5
    const nextOffsetY = 5

    let nextClientX = mouseClientX + nextOffsetX
    let nextClientY = mouseClientY + nextOffsetY - 80

    if (nextClientX + width > boxWidth) {
      nextClientX = mouseClientX - nextOffsetX - width
    }

    if (nextClientY + tooltipHeight > boxHeight - 40) {
      if (nextClientY > boxHeight) {
        nextClientY =
          mouseClientY - nextOffsetY - tooltipHeight + boxHeight - nextClientY
      } else {
        nextClientY = mouseClientY - nextOffsetY - tooltipHeight - 70
        if (nextClientY < 0) nextClientY = nextOffsetY
      }
    }

    setState({
      clientX: nextClientX,
      clientY: nextClientY,
      offsetX: nextOffsetX,
      offsetY: nextOffsetY,
    })
  }

  if (
    !isVisible ||
    !targets ||
    !targets.length ||
    (state.clientY <= 0 && state.clientX <= 0)
  ) {
    return null
  }

  return (
    <section
      className={clsx(styles.tooltipContainer, { [styles.active]: active })}
      style={{
        left: state.clientX,
        top: state.clientY,
      }}
    >
      <SingleTooltip className={styles.targetItem} width={state.width} />
    </section>
  )
}
